
import Vue from 'vue'
import AppMixin from '@/_mixins/app'

import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import InfoPublic from '@/views/Project/HSE/views/InfoPublic/InfoPublic.vue'
import HseContacts from '@/views/Project/HSE/views/HseContacts.vue'
import Documents from '@/views/Project/HSE/views/Documents/Documents.vue'
import ForbiddenView from '@/views/App/views/ForbiddenView/ForbiddenView.vue'
import ProjectMixin from '@/_mixins/project'
import VbitStatusBanner from '@/components/banner/vbitStatus.vue'

const HsePublicIndex = Vue.extend({
    mixins: [AppMixin, ProjectMixin],
    components: { AppToolbar, InfoPublic, HseContacts, Documents, ForbiddenView, VbitStatusBanner },

    data() {
        return {
            dialog: false,
        }
    },

    computed: {
        isPublic() {
            return this.$route.fullPath.includes('public') ? true : false
        },

        routeName() {
            return this.$route.name
        },

        allowedAccess() {
            return this.hasPermission(this.currentProjectPermissions, this.requiredPermissions)
        },
    },
})

export default HsePublicIndex
